<template>
  <v-container>
    <h1 class="text-h4">Import Terms to Study</h1>
    <p class="mt-5">
      Paste your terms, definitions, and optional examples here. Each line
      should contain a term, its definition and an optional example sentence
      separated by a semicolon.
    </p>
    <form @submit.prevent="onSubmit">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            :placeholder="placeholderText"
            v-model="inputText"
            rows="5"
            @input="parseInput"
            outlined
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-select
            :items="separators"
            v-model="separator"
            label="Split term and definition with"
            outlined
            @change="separatorChanged"
          ></v-select>
          <v-text-field
            v-if="customSeparator"
            v-model="customValue"
            label="Enter your separator"
            @input="separator = $event"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn color="blue darken-1" text @click="onCancel">Cancel</v-btn>
          <v-btn type="submit" color="blue darken-1" text>Import</v-btn>
        </v-col>
      </v-row>
    </form>
    <v-card class="mt-5" v-if="parsedData.length > 0">
      <v-card-title>
        Preview
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="parsedData"></v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    id: {
      required: true,
    },
  },

  data() {
    return {
      inputText: "",
      parsedData: [],
      separator: ";",
      customSeparator: false,
      customValue: "",
      separators: [";", ",", ":", "other"],
      headers: [
        { text: "Term", value: "term" },
        { text: "Definition", value: "meaning" },
        { text: "Example", value: "example" },
      ],
    };
  },

  computed: {
    placeholderText() {
      return `Word 1${this.separator} Definition 1${this.separator} Example 1 (optional)`; // updated this line
    },
    ...mapGetters(["studyList"]),
  },

  methods: {
    ...mapActions(["importTerms"]),
    parseInput() {
      const rows = this.inputText.trim().split("\n");
      const parsedData = rows.map((row) => {
        const [term, meaning, example = ""] = row
          .split(this.separator)
          .map((column) => column.trim());
        return { term, meaning, example };
      });
      this.parsedData = parsedData;
    },
    separatorChanged(val) {
      if (val === "other") {
        this.customSeparator = true;
        this.separator = this.customValue;
      } else {
        this.customSeparator = false;
        this.separator = val;
      }
      this.parseInput(); // parse the input when separator changes
    },
    onSubmit() {
      const termsForSubmit = this.parsedData.map(
        ({ term, meaning, example }) => {
          const trimmedExample = example.trim();
          return {
            term,
            meaning,
            examples: trimmedExample
              ? [{ content: trimmedExample, description: "" }]
              : [],
          };
        }
      );
      this.importTerms({
        studyListId: this.id,
        terms: termsForSubmit,
      }).then(() => {
        this.$router.push({
          name: "StudyListDetail",
          params: { id: this.id },
        });
      });
    },
    onCancel() {
      this.$router.push({
        name: "StudyListDetail",
        params: { id: this.id },
      });
    },
  },
};
</script>
